import React from 'react';
import Header from './Header';
import Footer from './Footer';
import FeedbackWidget from '../common/FeedbackWidget';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-off-white">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <FeedbackWidget />
    </div>
  );
};

export default Layout;
